// extracted by mini-css-extract-plugin
export var markdown = "_sh-0";
export var tableWrapper = "_sh-1";